import React from 'react';
import WorkoutManagerAdapter from './WorkoutManagerAdapter';
import { debugLog } from '../../utils/logger';

const WorkoutManager = ({ user, onClose, onSuccess, mode = 'view', initialWorkout = null }) => {
  // Debug logging to check what's being passed to WorkoutManager
  //debugLog("WorkoutManager props:", { user, mode, initialWorkout });
  
  return (
    <WorkoutManagerAdapter
      user={user}
      onClose={onClose}
      onSuccess={onSuccess}
      mode={mode}
      initialWorkout={initialWorkout}
    />
  );
};

export default WorkoutManager;